module.exports = __webpack_public_path__ + "static/media/home.c5cff3c8.svg";